import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSlideToggleModule, MatStepperModule, MatTabsModule, MatTooltipModule, MatSelectModule, MatDialogModule, MatButtonToggleModule, MatRadioModule, } from '@angular/material';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TableModule } from 'primeng/table';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table'
import { RouterModule } from '@angular/router';
import { OnboardComponent } from './onboard.component';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { MatChipsModule } from '@angular/material';
import { PasswordStrengthMeterModule } from 'angular-password-strength-meter';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

const routes = [
  { path: 'onboard-login', component: OnboardComponent },
];

@NgModule({
  declarations: [OnboardComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FuseSharedModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(maskConfig),
    MatTooltipModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FlexLayoutModule,
    TableModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTabsModule,
    MatDividerModule,
    MatSelectModule,
    MatTableModule,
    Ng2TelInputModule,
    MatChipsModule,
    PasswordStrengthMeterModule,
    NgxIntlTelInputModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatRadioModule,
  ]
})
export class OnboardModule { }
